import React from 'react';
import { Route, Routes, useLocation } from "react-router-dom";
// internal
import BackToTop from '../components/BackToTop';
import ContextProvider from '../components/context/ContextProvider';
// import Home from '../components/Home/Home';
import HomeThree from '../components/HomeThree/HomeThree';
import HomeTwo from '../components/HomeTwo/HomeTwo';
import About from '../components/Pages/About/About';
import Blog from '../components/Pages/Blog/Blog';
import BlogDetails from '../components/Pages/BlogDetails/BlogDetails';
import ContactUs from '../components/Pages/ContactUs/ContactUs';
import FAQ from '../components/Pages/FAQ/FAQ';
import Portfolio from '../components/Pages/Portfolio/Portfolio';
import PortfolioDetails from '../components/Pages/PortfolioDetails/PortfolioDetails';
import Price from '../components/Pages/Price/Price';
import Service from '../components/Pages/Service/Service';
import ServiceDetails from '../components/Pages/ServiceDetails/ServiceDetails';
import TeamDetails from '../components/Pages/TeamDetails/TeamDetails';
import TeamPage from '../components/Pages/TeamPage/TeamPage';
import NewInstallation from '../components/Pages/NewInstallation/NewInstallation';
import MaintenanceContract from '../components/Pages/MaintenanceContract/MaintenanceContract';
import Modification from '../components/Pages/Modification/Modification';
import RepairandService from '../components/Pages/RepairandService/RepairandService';
import Products from '../components/Pages/Products/Products';
import ProductDetails from '../components/Pages/Productdetails/ProductDetails';
import Career from '../components/Pages/Career/Career';
// import FireSafetyPage from '../components/Firesafety/FireSafetyPage';
import Greenenergy from '../components/Greenenergy/Greenenergy';
import Fire from '../components/Firesafety/Fire';

import Splash from '../components/Splash/Splash';



const AppNavigation = () => {
  const location = useLocation();
  const isSplashPage = location.pathname === '/' || location.pathname === '/splash';

  return (
    <ContextProvider>
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/home-2" element={<HomeTwo />} />
        <Route path="/home-3" element={<HomeThree />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/team-details" element={<TeamDetails />} />
        <Route path="/service" element={<Service />} />
        <Route path="/service-details" element={<ServiceDetails />} />
        <Route path="/price" element={<Price />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio-details/:id" element={<PortfolioDetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path='/new-installation' element={<NewInstallation />} />
        <Route path='/maintenance-contract' element={<MaintenanceContract />} />
        <Route path='/modification' element={<Modification />} />
        <Route path='/repair-and-service' element={<RepairandService />} />
        <Route path='/products/:category' element={<Products />} />
        <Route path='/Product-details/:id' element={<ProductDetails />} />
        <Route path="/career" element={<Career />} />
        <Route path="/green" element={<Greenenergy />} />
        <Route path="/fire" element={<Fire />} />
        <Route path="/splash" element={<Splash />} />







      </Routes>
      {!isSplashPage && <BackToTop />}
    </ContextProvider>
  );
};

export default AppNavigation;